const typeContent = {
  fileDownload: {
    eventDetail: "file_download",
  },
  videoPlay: {
    eventDetail: "video_start",
  },
  podcastPlay: {
    eventDetail: "podcast_start",
  },
  linkShare: {
    eventDetail: "link_share",
  },
  internalLink: {
    eventDetail: "internal_link",
  },
};

export function pushData({
  event,
  eventType,
  componentType,
  componentTitle,
  componentLink,
  componentLinkText,
}) {
  window.digitalData.push({
    event: event,
    eventDetail: {
      name: typeContent[event].eventDetail,
      type: eventType,
    },
    component: {
      type: componentType,
      title: componentTitle,
      link: componentLink,
      linkText: componentLinkText,
    },
  });
}
